export const TaskStatus = [
    { 'value': 'readyToStart', 'label': 'Ready To Start' },
    { 'value': 'started', 'label': 'Started' },
    { 'value': 'completed', 'label': 'Completed' },
    { 'value': 'cancelled', 'label': 'Cancelled' }
];
